import { PlayerEvent } from '../PlayerEvent';
import { ReactComponent as QuickbackIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-undo.svg';

export function QuickbackEvent({ timestamp, active, ...rest }) {
  return <PlayerEvent icon={QuickbackIcon} title="Quickback" timestamp={timestamp} active={active} {...rest} />;
}
